import { Link, LinkProps } from './Link';

export const NEW_TAB_LINK_TEST_ID = 'new-tab-link';

/**
 * Link variant to be used when a link opens in another tab.
 */
export const NewTabLink = ({ children, href, ...props }: LinkProps) => (
  <Link
    data-test={NEW_TAB_LINK_TEST_ID}
    href={href}
    hasOpenNewTabIcon
    target="_blank"
    rel="noopener noreferrer"
    {...props}
  >
    {children}
  </Link>
);
